// TODO : Allow other locales than FR and EN to be displayed.
//
// Note that for all non-fr locales, the default english highcharts translations will be
// used.
//
export const initializeHighchartsLocale = Highcharts => {
  const locale = document.documentElement.lang || "en";

  // This is a shortcut that means Highcharts does not use UTC but the browser's local
  // time zone.
  Highcharts.setOptions({ time: { useUTC: false } });

  if (locale !== "fr") return;

  Highcharts.setOptions({
    lang: {
      months: [
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre"
      ],
      weekdays: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      shortMonths: [
        "Jan",
        "Fev",
        "Mar",
        "Avr",
        "Mai",
        "Juin",
        "Juil",
        "Aout",
        "Sept",
        "Oct",
        "Nov",
        "Déc"
      ],
      decimalPoint: ",",
      downloadPNG: "Télécharger le graphique en PNG",
      downloadJPEG: "Télécharger le graphique en JPEG",
      downloadPDF: "Télécharger le graphique en PDF",
      downloadSVG: "Télécharger le graphique en SVG",
      downloadCSV: "Télécharger les données en CSV",
      downloadXLS: "Télécharger les données en XLS",
      viewData: "Voir les données",
      hideData: "Masquer les données",
      viewFullscreen: "Voir en plein écran",
      exitFullscreen: "Sortir du plein écran",
      exportData: {
        annotationHeader: "Annotations",
        categoryDatetimeHeader: "Date",
        categoryHeader: "Catégorie"
      },
      exportButtonTitle: "Export du graphique",
      loading: "Chargement en cours...",
      printChart: "Imprimer le graphique",
      resetZoom: "Réinitialiser le zoom",
      resetZoomTitle: "Réinitialiser le zoom au niveau 1:1",
      thousandsSep: " ",
      noData: "Aucune donnée à afficher",
      contextButtonTitle: "Exports, impressions et autres vues"
    },
    tooltip: {
      dateTimeLabelFormats: {
        week: "Semaine du %d %b %Y"
      }
    }
  });
};
